import qs from 'qs';
import { ITEMS_PER_PAGE } from '../hooks/useFetchList';

export const getEndpoint = (
  baseEndpoint,
  baseParams,
  sorting = [],
  newFilter = [],
) => {
  const filters = (newFilter || []).filter(({value}) => {
    if (Array.isArray(value)) {
      return value.length > 0 && value.join('').replace(' ', '').length > 0;
    } else {
      return !!value;
    }
  }).map(
    ({id, value}) => {
      let resultFilter = '';
      if (Array.isArray(value)) {
        value.forEach(filterKey => {
          const base64 = window.btoa(unescape(encodeURIComponent(filterKey)));
          resultFilter += base64 + ',';
        });
        resultFilter = resultFilter.slice(0, resultFilter.length - 1);
      } else {
        resultFilter += value;
      }
      return `${id}:${resultFilter}`;
    },
  );

  if (baseParams.q) {
    filters.push(baseParams.q);
  }

  let sort;
  if (sorting && sorting.length) {
    const {id, desc} = sorting[0];

    const direction = desc ? '-' : '';
    sort = `${direction}${id}`;
  }
  const qsParams = {
    ...baseParams,
    q: filters,
    sort,
    pageSize: ITEMS_PER_PAGE,
  };
  return `${baseEndpoint}${qs.stringify(qsParams, {
    addQueryPrefix: true,
    arrayFormat: 'repeat',
  })}`;
};

export const getTokenEndpoint = (baseEndpoint, token) =>
  `${baseEndpoint}${qs.stringify(
    {
      'continuation-token': token,
    },
    { addQueryPrefix: true },
  )}`;
